import repository from '@/repositories/repository'
import url from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/estado`

    return {
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${url.serialize(queryParms)}`)
        },
    }
}